module.exports = __webpack_public_path__ + "img/b3.1024575d.png";